<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item label="生效年份：">
      <el-date-picker
        v-model="filters.effectYear"
        type="year"
        :editable="false"
        :clearable="false"
        placeholder="选择生效年份"
        value-format="yyyy"
        style="width: 160px;"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item >
      <el-input
        v-model="filters.deptName"
        placeholder="请输入适用组织名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
export default {
  name: "search",
  components: {
    butn
  },
  data() {
    return {
      size: "small",
      filters: {
        effectYear: String(new Date().getFullYear()),
      }
    };
  },
  created() {
    this.$nextTick(() => {
      this.initData();
    })
  },
  methods: {
    initData() {
      this.$emit("search", {...this.filters,t: new Date().getTime()});
    },
    resetData() {
      //重置
      this.filters = {
        effectYear: String(new Date().getFullYear())
      };
      this.initData();
    }
  }
};
</script>
